module.exports = __webpack_public_path__ + "static/Slider7-55f75c8efd47a27aac0029a8c5f1060e.jpg";